import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService, DID_URL, hd, LoggerService, RestClientBaseService } from '@nx-fe/services';
import { Observable } from 'rxjs';

@Injectable()
export class XSightRestClientService extends RestClientBaseService {
  useXSightAuth = false;

  constructor(
    private httpClient: HttpClient,
    private appSettingService: AppSettingsService,
    loggerService: LoggerService
  ) {
    super(httpClient, appSettingService, loggerService);
  }

  // Override login url to use Assist OAuth
  get loginURL(): string {
    // let url: URL;
    // this.useXSightAuth = this.featureToggleService.isEnabled('XSightAuthToken');
    // let state = 'https://' + window.location.host + '/';
    // const pathComponents = window.location.pathname.split('/');
    // if (pathComponents && pathComponents.length > 1) {
    //   state += pathComponents.slice(1).join('/');
    //   state += window.location.search;
    // }
    return '/login';
  }

  // Override logout
  logout(): void {}

  getTicket(ticketId: string): Observable<hd.ITicketModel> {
    return this.httpClient.get<hd.ITicketModel>(`/sotixsight/tickets/${ticketId}`);
  }

  getDeviceManagementAddress(): Observable<hd.IUrlModel> {
    return this.httpClient.get<hd.IUrlModel>(this.appSettingService.sspServiceUrl + 'devicemanagementaddress');
  }

  setAgentConnectionConfig(data): Observable<any> {
    const url = `${DID_URL}/pcg/agentconfig`;
    return this.http.post<any>(url, data);
  }

  getAgentConnectionConfig(): Observable<any> {
    const url = `${DID_URL}/pcg/agentconfig`;
    return this.http.get<any>(url);
  }
}
